























import { Component, Ref, Vue } from 'vue-property-decorator';
import UserIcon from '@/components/global/UserIcon.vue';
import { store } from '@/utils/store';

@Component({
  components: {
    UserIcon,
  },
})
export default class CallStatus extends Vue {
  @Ref() audioElement!: HTMLAudioElement
  muted = false

  get targetUser() {
    return store.callTarget || '';
  }

  get calling() {
    return store.callStatus !== 'none';
  }

  mute() {
    if (!store.callConn?.stream) return;
    this.muted = !this.muted;
    store.callConn.stream.getAudioTracks().forEach((track) => {
      // eslint-disable-next-line no-param-reassign
      track.enabled = !this.muted;
    });
  }

  hangup() {
    store.callEnd();
  }

  deny() {
    store.callDeny();
  }

  accept() {
    store.callStart();
  }
}
